export const typeMassActionsText = {
  addComment: 'Вы добавляете комментарий',
  dataTime: 'Вы изменяете дату назначения',
  exucutor: 'Вы изменяете исполнителя',
  master: 'Вы изменяете мастера',
  paymentStatus: 'Вы изменяете статус оплаты',
  sign: 'sign',
  state: 'Вы изменяете статус',
  stageReuest:
    'Вы изменяете стадию помещения, установленную при создании заявки',
}

export const getDeclinedWord = (count) => {
  const forms = {
    one: "заявки",
    two: "заявок",
  }

  const numStr = String(count);

  if (numStr.length > 1 && numStr[numStr.length - 1] === '1' && ((numStr[numStr.length - 2] >= '2' && numStr[numStr.length - 2] <= '9') || numStr[numStr.length - 2] === '0')) {
    return `у ${count} ${forms.one}`
  }

  else {
    return `у ${count} ${forms.two}`
  }
}

export const objEstablish = {
  IsInternal: 'Признак “внутренняя” будет установлен, заявка не будет доступна для просмотра собственникам.',
  isChargeable: 'Признак “платная” будет установлен. Убедитесь, что собственник осведомлён о необходимости оплаты.',
  isImmediate: 'Признак “аварийная” будет установлен, заявка станет срочной. Убедитесь, что ситуация действительно аварийная.'
}

export const objtTakeOff = {
  IsInternal: 'Признак “внутренняя” будет снят, заявка станет доступна для просмотра собственникам.',
  isChargeable: 'Признак “платная” будет снят, собственник не сможет произвести оплату через мобильное приложение.',
  isImmediate: 'Признак “аварийная” будет снят, заявка перестанет быть срочной. Убедитесь, что авария устранена.'
}